import React, { FC, memo } from 'react';

import AnalyticsService, { EventNameAMP, ParamNameAMP, CalledFromValues } from 'application/services/AnalyticsService';
import { LAW_CONST } from 'application/pages/constants';

import { Country } from 'domain/api/graphql/generated';

import { TEXTS } from './texts';

import styles from './index.module.scss';

interface Props {
  country: Country;
}

export const CookiePolicy: FC<Props> = memo(({ country }) => {
  const onOfertaClick = () => {
    AnalyticsService.event(EventNameAMP.SHOW_OFERTA_PRESSED, {
      [ParamNameAMP.CALLED_FROM]: CalledFromValues.SIGN_UP_PAGE,
      [ParamNameAMP.COMPANY_COUNTRY]: country,
    });
  };

  const onCookieClick = () => {
    AnalyticsService.event(EventNameAMP.SHOW_COOKIE_POLICY_PRESSED, {
      [ParamNameAMP.CALLED_FROM]: CalledFromValues.SIGN_UP_PAGE,
      [ParamNameAMP.COMPANY_COUNTRY]: country,
    });
  };

  return (
    <div className={styles.cookiePolicy}>
      <span>{TEXTS.OFERTA_TITLE}</span>
      <a
        href={LAW_CONST.PUBLIC_OFFER_URL_BY}
        onClick={onOfertaClick}
        target="_blank"
        rel="noopener noreferrer">
        {TEXTS.OFERTA_LINK}
      </a>
      <span>{TEXTS.COOKIE_POLICY_TITLE}</span>
      <a
        href={LAW_CONST.COOKIE_URL_BY}
        onClick={onCookieClick}
        target="_blank"
        rel="noopener noreferrer">
        {TEXTS.COOKIE_POLICY_LINK}
      </a>
    </div>
  );
});
